<template>
  <div v-if="value" class="field-instagram">
    <InputComponent
      :label="$t('instagramProfile')"
      v-model="value.slug"
      placeholder="..."
      data-field="slug"
      prefix="instagram.com/"
    />
    <InputComponent
      :label="$t('numberOfPosts')"
      v-model.number="value.items"
      data-field="items"
      type="number"
      align="right"
    />
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { Clone } from '../utils'
import Template from '../Templates/Instagram'

export default {
  props: {
    label: String,
    value: Object,
  },
  created() {
    if (!this.value) this.$emit('input', Clone(Template))
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss">
.field-instagram {
  display: grid;
  grid-template-columns: 1fr 120px;
  grid-gap: 1rem;
}
</style>
